<template>
    <vx-card :style="style" v-on="$listeners" v-bind="attrs">
        <slot v-for="slot in Object.keys($slots)" :name="slot" :slot="slot"></slot>
        <!-- Pass on all scoped slots -->
        <template v-for="slot in Object.keys($scopedSlots)" :slot="slot" slot-scope="scope">
            <slot :name="slot" v-bind="scope"></slot>
        </template>
    </vx-card>
</template>

<script>
import _colors from '@/assets/utils/color.js'
export default {
    name: 'vx-styled-card',
    props: {
        color: {
            type: String,
            default: 'primary'
        },
        leftBorderSize: {
            type: [String, Number],
            default: '5'
        }
    },
    data() {
        return {}
    },
    watch: {},
    computed: {
        accentColor_x() {
            return _colors.getColor(this.color)
        },
        attrs() {
            return {
                ...this.$attrs
            }
        },
        style() {
            return {
                borderLeft: `${this.leftBorderSize}px solid ${this.accentColor_x} !important`
            }
        }
    },
    methods: {}
}
</script>

<style lang="scss" scoped></style>
